import max from 'lodash-es/max';
import min from 'lodash-es/min';
import sum from 'lodash-es/sum';
import {
  ProductType,
  TradeDirection,
  TradeFlow,
} from '../../graphQL/types/shared';
import {
  computeGrossNetTradeValues,
} from '../../tree/newChart/transformUtils';
import {
  FetchedDatum,
} from './index';

export default (fetchResult: FetchedDatum[]) => {
  const withComputedTradeValues = computeGrossNetTradeValues(
    fetchResult, TradeDirection.export, TradeFlow.Gross,
  );
  const withServicesRemoved = withComputedTradeValues.filter(elem => elem.product.type === ProductType.Goods);
  const allPCIS: number[] = [];
  for (const {pci} of withServicesRemoved) {
    if (pci !== null) {
      allPCIS.push(pci);
    }
  }
  return {
    max: max(allPCIS)!,
    min: min(allPCIS)!,
    average: sum(allPCIS) / allPCIS.length,
  };
};
